import type { CityConfig } from "../city-template/types";

export const pontiacConfig: CityConfig = {
  city: "Pontiac",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "pontiac",
  route: "/cities/pontiac",
  title: "Emergency Passport Pontiac MI | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Pontiac, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Pontiac, Auburn Hills, Waterford, Bloomfield Township, and all Oakland County residents. Detroit Passport Agency courier. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Pontiac, MI",
  heroSubtitle: "Pontiac travelers — from the historic Oakland County seat to the automotive heritage corridor to the Waterford Township communities — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Detroit Passport Agency is just 35 minutes south. A+ BBB rated courier service serving all of Oakland County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Downtown%20Pontiac%20Michigan%20historic%20district%20with%20the%20Oakland%20County%20Courthouse%20and%20surrounding%20brick%20buildings%2C%20wide%20street%20view%20with%20vintage%20architecture%20and%20modern%20revitalization%2C%20autumn%20maple%20trees%20lining%20the%20avenue%2C%20warm%20golden%20afternoon%20light%2C%20urban%20downtown%20with%20clear%20sky%2C%20no%20text%20no%20people%2C%20photorealistic%20architectural%20photography%20with%20warm%20earth%20tones%20and%20muted%20sky&width=1800&height=700&seq=pontiac-hero-001&orientation=landscape",
  heroImageAlt: "Downtown Pontiac Michigan historic district with Oakland County Courthouse and brick buildings",
  geoPosition: "42.6389;-83.2911",
  geoPlacename: "Pontiac, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "211 W. Fort St, Suite 1300, Detroit, MI 48226",
    distance: "Approximately 35–40 minutes south via I-75 — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Pontiac", zips: "48340, 48341, 48342, 48343" },
    { name: "Auburn Hills", zips: "48321, 48326" },
    { name: "Waterford", zips: "48327, 48328, 48329" },
    { name: "Bloomfield Township", zips: "48301, 48302, 48304" },
    { name: "Rochester Hills", zips: "48306, 48307, 48309" },
    { name: "Lake Orion", zips: "48359, 48360, 48362" },
    { name: "Troy", zips: "48083, 48084, 48085, 48098" },
    { name: "Royal Oak", zips: "48067, 48068, 48073" },
    { name: "Birmingham", zips: "48009, 48012" },
    { name: "Southfield", zips: "48033, 48034, 48075, 48076" },
    { name: "Farmington Hills", zips: "48331, 48333, 48334, 48335, 48336" },
    { name: "Novi", zips: "48374, 48375, 48377" },
    { name: "Walled Lake", zips: "48390" },
    { name: "Wixom", zips: "48393" },
    { name: "Clarkston", zips: "48346, 48348" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-truck-line", title: "Oakland County Coverage", desc: "Serving Pontiac, Auburn Hills, Waterford, Rochester Hills, and all Oakland County" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — stay home while we do the work" },
  ],
  internalLinks: [
    { name: "Expedited passport in Detroit, MI", route: "/cities/detroit" },
    { name: "Emergency passport services in Troy, MI", route: "/cities/troy-mi" },
    { name: "Urgent passport services in Southfield, MI", route: "/cities/southfield" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Pontiac, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Pontiac residents can ship from any UPS or FedEx in Oakland County.",
  fpcOfficeDistance: "Serving Pontiac, Auburn Hills, Waterford, Bloomfield Township, Rochester Hills, Lake Orion, Troy, Royal Oak, Birmingham, Southfield, Farmington Hills, Novi, Walled Lake, Wixom, and Clarkston",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Pontiac and the greater Oakland County area. From the historic Oakland County seat downtown to the Auburn Hills business corridor to the Waterford Township lakes — we serve all of Oakland County. Pontiac is the county seat and a historic automotive city, and our couriers have direct access to the Detroit Passport Agency just 35 minutes south.",
  nearbyCitiesIntro: "We serve Pontiac and all Oakland County communities including Auburn Hills, Waterford, Bloomfield Township, Rochester Hills, Lake Orion, Troy, Royal Oak, Birmingham, Southfield, Farmington Hills, Novi, Walled Lake, Wixom, and Clarkston. We also serve neighboring Wayne and Macomb counties.",
  howItWorksIntro: "Most Pontiac travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Pontiac and Oakland County residents include working professionals, automotive industry employees, and families. Here are the most common passport mistakes we see from northern Detroit suburbs travelers.",
  testimonialsIntro: "Pontiac travelers — from Oakland County government workers to automotive professionals to families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Pontiac, MI? Here are the most common ones we hear from Oakland County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Pontiac travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, family emergencies, and international travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Business and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Pontiac adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Oakland County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Pontiac residents and families — including new citizens, young professionals, and Oakland County residents applying for their first passport.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Pontiac residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Pontiac-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Pontiac and Oakland County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Pontiac MI", description: "Urgent passport processing for Pontiac Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Pontiac MI", description: "Fast passport renewal for Pontiac Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Pontiac MI", description: "New passport application services for Pontiac Michigan residents applying for their first passport." },
    { name: "Child Passport Pontiac MI", description: "Minor passport services for Pontiac Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael D.",
      location: "Pontiac, MI",
      rating: 5,
      text: "Business trip to Japan in 5 days and my passport expired. Fast Passport Center handled everything — delivered my renewed passport in 36 hours. I didn't have to drive to downtown Detroit once.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Karen S.",
      location: "Auburn Hills, MI",
      rating: 5,
      text: "Family vacation to Mexico with 10 days notice. Three passports for our family. Done in 4 days. We shipped from the UPS on University Drive and everything went smooth.",
      service: "Family Passport Bundle",
    },
    {
      name: "James R.",
      location: "Waterford, MI",
      rating: 5,
      text: "First-time passport at 50 for a retirement trip to Ireland. Fast Passport Center scheduled my acceptance facility appointment and handled everything. The process was completely hands-off.",
      service: "First-Time Passport",
    },
    {
      name: "Nadia T.",
      location: "Rochester Hills, MI",
      rating: 5,
      text: "Needed to travel to Canada for a family emergency and my passport was misplaced. Fast Passport Center walked me through the process and had a replacement in my hands in 48 hours.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "pontiac-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "211 W. Fort St, Suite 1300",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 35–40 minutes south of Pontiac via I-75",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "pontiac-2",
      name: "Pontiac Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Huron St",
      city: "Pontiac",
      state: "MI",
      zip: "48342",
      phone: "(248) 338-5040",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Pontiac — near Oakland County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Pontiac acceptance facility. Convenient for downtown Pontiac and Oakland County government employees. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "pontiac-3",
      name: "Auburn Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2955 Lapeer Rd",
      city: "Auburn Hills",
      state: "MI",
      zip: "48326",
      phone: "(248) 373-2700",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Auburn Hills — approximately 6 miles east of Pontiac",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Auburn Hills and eastern Pontiac residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "pontiac-4",
      name: "Waterford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4300 Highland Rd",
      city: "Waterford",
      state: "MI",
      zip: "48328",
      phone: "(248) 682-4400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Waterford — approximately 5 miles west of Pontiac",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Pontiac and Waterford Township residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "pontiac-5",
      name: "Troy Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2844 Crooks Rd",
      city: "Troy",
      state: "MI",
      zip: "48084",
      phone: "(248) 649-3410",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Troy — approximately 15 miles south of Pontiac",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Oakland County residents including Troy, Birmingham, and Bloomfield Hills. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Oakland County" },
    { feature: "Oakland County Expertise", agency: "No tailored advice", fpc: "Yes — Pontiac, Auburn Hills, Waterford, Rochester Hills" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Pontiac and Oakland County residents often discover passport issues right before planned travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel",
      description: "Many Oakland County residents use a passport card for land crossings to Canada — but these are not valid for air travel. If you fly internationally, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Pontiac-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking International Driving Requirements",
      description: "Pontiac travelers renting cars abroad should verify international driving permit requirements in addition to passport requirements. Some countries require both.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Oakland County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Pontiac or Oakland County." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Pontiac-area address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the Detroit Passport Agency from Pontiac?", a: "The Detroit Passport Agency is located at 211 W. Fort St, Suite 1300, Detroit, MI 48226, approximately 35–40 minutes south of Pontiac via I-75. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access to submit applications without individual appointments." },
    { q: "How fast can I get an emergency passport in Pontiac?", a: "Fast Passport Center offers emergency passport processing in Pontiac, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive to downtown Detroit." },
    { q: "Can I get an expedited passport in Pontiac suburbs like Auburn Hills, Waterford, or Rochester Hills?", a: "Absolutely. Fast Passport Center serves all of Oakland County including Pontiac, Auburn Hills, Waterford, Bloomfield Township, Rochester Hills, Lake Orion, Troy, Royal Oak, Birmingham, Southfield, Farmington Hills, Novi, Walled Lake, Wixom, and Clarkston. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Pontiac-area travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Pontiac and Oakland County travelers. DTW is approximately 40–50 minutes from Pontiac via I-75. It offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and dozens of other international destinations. Oakland County International Airport (PTK) in Waterford is a secondary option for charter and private flights. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Pontiac, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Pontiac residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Pontiac and Oakland County offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula of Michigan?", a: "Yes. Fast Passport Center's courier service is especially valuable for Upper Peninsula residents, who would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Escanaba, Houghton, and all UP communities — you just ship your documents overnight and we handle everything from there." },
    { q: "What is the best way for Pontiac residents to get to the Detroit Passport Agency?", a: "The fastest route from Pontiac to the Detroit Passport Agency is south on I-75 to downtown Detroit, then to 211 W. Fort St in the Patrick V. McNamara Federal Building. The drive is approximately 35–40 minutes. However, you don't need to go there yourself — Fast Passport Center's registered couriers handle the in-person submission for you. You simply ship your documents from any UPS or FedEx in Pontiac or Oakland County." },
  ],
  photoLocations: [
    { name: "Walgreens — Pontiac Huron", address: "81 E Huron St, Pontiac, MI 48342", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Auburn Hills", address: "3185 Lapeer Rd, Auburn Hills, MI 48326", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Pontiac", address: "100 E Huron St, Pontiac, MI 48342", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Troy", address: "675 E Big Beaver Rd, Troy, MI 48083", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Pontiac", address: "550 E Woodward Ave, Pontiac, MI 48342", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Pontiac and central Oakland County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Waterford", address: "5100 Highland Rd, Waterford, MI 48327", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Waterford, Clarkston, and western Oakland County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "40–50 minutes from Pontiac via I-75",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Pontiac and Oakland County travelers. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "PTK",
      name: "Oakland County International Airport",
      distance: "10 minutes from Pontiac — charter and private only",
      address: "6500 Highland Rd, Waterford, MI 48327",
      note: "Smaller regional airport primarily for charter and private flights. Not used for commercial international travel. DTW remains the main gateway for international departures.",
      flightUrl: "https://www.oakgov.com/aviation/",
      flightLabel: "Oakland County Airport Info",
      featured: false,
    },
  ],
};